import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { InlineOverlay, InlineOverlayBody, InlineOverlayFooter, InlineOverlayHeader } from '@bibliocommons/base-inline-overlay';
import * as bcPropTypes from '@bibliocommons/bc-prop-types';
import { SHELF_NAMES, WORKFLOW_VIEWS } from '../../../constants/ShelfConstants';
import Rating from '@bibliocommons/rating';
import { AlertSuccess } from '@bibliocommons/base-alerts';
import OnShelfDropdown from '../OnShelfDropdown/OnShelfDropdown';
import { DefaultButton } from '@bibliocommons/base-buttons';
import PrivacyTogglePills from '@bibliocommons/shared-privacy-toggle-pills';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';

import './ItemAddedToShelfView.scss';

class ItemAddedToShelfView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('toggleItemPrivacy', 'handleUpdateRating', 'handleRemoveRating', 'renderRatingSection', 'getSuccessMessageStringId', 'handleUpdateShelfItem', 'handleRemoveShelfItem');
  }

  toggleItemPrivacy(isPrivate) {
    const { shelfItem } = this.props;
    const shelfName = shelfItem.get('shelf');

    BCGoogleAnalyticsUtils.event({
      eventCategory: 'NERF Search',
      eventAction: 'Change item privacy',
      eventLabel: isPrivate ? 'Private' : 'Shared'
    });

    return this.handleUpdateShelfItem(shelfName, shelfItem.get('id'), shelfItem.get('metadataId'), {
      newShelfName: shelfName,
      privateItem: isPrivate
    });
  }

  handleUpdateRating(rating) {
    const { rateItem, changeItemRating, bib, currentUserRating } = this.props;
    // updates existing rating
    if (currentUserRating) {
      return changeItemRating(bib.get('id'), rating);
    }

    // adds new rating
    return rateItem(bib.get('id'), rating);
  }

  handleRemoveRating() {
    const { removeItemRating, bib, currentUserRating } = this.props;
    return removeItemRating(bib.get('id'), currentUserRating.get('id'));
  }

  handleUpdateShelfItem(shelfName, id, metadataId, fieldsToUpdate) {
    return this.props.updateShelfItems({
      shelfName,
      shelfItemIds: [id],
      metadataIds: [metadataId],
      ...fieldsToUpdate
    });
  }

  handleRemoveShelfItem(shelfName, id, metadataId) {
    this.props.removeShelfItems({
      shelfName,
      shelfItemIds: [id],
      metadataIds: [metadataId],
      workflowId: this.props.workflowId
    });
  }

  renderRatingSection() {
    const { shelfItem, bib, currentUserRating, ratingsTransactions } = this.props;
    const shelfName = shelfItem.get('shelf');
    const metadataId = bib.get('id');
    const isLoading = ratingsTransactions.getIn([metadataId, 'isLoading'], false);

    if (shelfName === SHELF_NAMES.COMPLETED) {
      return (
        <div className="post-success-rating">
          <Rating
            id={`added_to_shelf_rating_${metadataId}`}
            isLoading={isLoading}
            rating={currentUserRating ? currentUserRating.get('rating') : null}
            handleButtonClick={this.handleUpdateRating}
            handleRemoveClick={this.handleRemoveRating} />
        </div>
      );
    }

    return null;
  }

  renderShelfSelectDropdown() {
    return (
      <OnShelfDropdown
        currentShelfItem={this.props.shelfItem}
        updateShelfItem={this.handleUpdateShelfItem}
        removeShelfItem={this.handleRemoveShelfItem} />
    );
  }

  getSuccessMessageStringId() {
    const { shelfItem } = this.props;
    const shelfName = shelfItem.get('shelf');
    const isPrivate = shelfItem.get('privateItem', false);

    if (isPrivate) {
      return `message_add_to_${shelfName}_library`;
    }

    return `message_shared_on_${shelfName}_library`;
  }

  renderPostSuccessMessage() {
    const { bib, view } = this.props;
    const bibTitle = bib.get('title');

    if (view === WORKFLOW_VIEWS.EXISTS_ON_SHELF) {
      return null;
    }

    return (
      <AlertSuccess className="hidden-xs">
        <FormattedHTMLMessage
          id={this.getSuccessMessageStringId()}
          values={{ titles: bibTitle }} />
      </AlertSuccess>
    );
  }

  render() {
    const { handleClose, shelfItem } = this.props;
    const isPrivate = shelfItem.get('privateItem') || false;

    return (
      <InlineOverlay handleClose={handleClose}>
        <InlineOverlayHeader />
        <InlineOverlayBody>
          <div className="post-shelf-success-body">
            { this.renderShelfSelectDropdown() }
            <PrivacyTogglePills isPrivate={isPrivate} handlePrivacyToggle={this.toggleItemPrivacy} />
            { this.renderRatingSection() }
          </div>
        </InlineOverlayBody>
        <InlineOverlayFooter>
          <DefaultButton handleClick={handleClose}>
            <FormattedMessage id="button_close" />
          </DefaultButton>
        </InlineOverlayFooter>
      </InlineOverlay>
    );
  }
}

ItemAddedToShelfView.propTypes = {
  workflowId: PropTypes.string,
  rateItem: PropTypes.func.isRequired,
  changeItemRating: PropTypes.func.isRequired,
  removeShelfItems: PropTypes.func.isRequired,
  removeItemRating: PropTypes.func.isRequired,
  updateShelfItems: PropTypes.func.isRequired,
  bib: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  shelfItem: bcPropTypes.shelfItemShape,
  currentUserRating: ImmutablePropTypes.mapContains({
    id: PropTypes.number,
    metadataId: PropTypes.string,
    userId: PropTypes.number,
    rating: PropTypes.number
  }),
  ratingsTransactions: ImmutablePropTypes.map.isRequired
};

ItemAddedToShelfView.displayName = 'ItemAddedToShelfView';

export default ItemAddedToShelfView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemAddedToShelfView/ItemAddedToShelfView.jsx